import { render } from "./FaixaNumeros.vue?vue&type=template&id=d1d1b8d8&scoped=true&ts=true"
import script from "./FaixaNumeros.vue?vue&type=script&lang=ts"
export * from "./FaixaNumeros.vue?vue&type=script&lang=ts"

import "./FaixaNumeros.vue?vue&type=style&index=0&id=d1d1b8d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d1b8d8"]])

export default __exports__